<template>
  <span class="recharge-status">
    <Tag :color="nodeStateTagText.color">{{ nodeStateTagText.text }}</Tag>
  </span>
</template>
<script>
export default {
  name: 'RechargeStatus',
  props: {
    nodeState: {
      type: Number,
      default: 3,
      required: true
    }
  },
  computed: {
    nodeStateTagText () {
      const state = this.nodeState
      const tagText = {
        color: 'default',
        text: '未知'
      }
      if (state === 0) {
        tagText.color = 'blue'
        tagText.text = '充值中'
      } else if (state === 1) {
        tagText.color = 'cyan'
        tagText.text = '充值成功'
      } else if (state === 2) {
        tagText.color = 'red'
        tagText.text = '充值失败'
      }
      return tagText
    }
  }
}
</script>
